import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import React, { useContext, useEffect, useState } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AiFillDelete } from "react-icons/ai";
import { server } from "../../../common";
import useQuickLook from "../../../quicklook/useQuickLook";
import { useSelectAccess } from "../../../store/stateFunctions";
import { NavLink } from "react-router-dom";
import configContext from "../../../context/configContext/configContext";

const swalalert = withReactContent(Swal);

const AmbassadorEntries = () => {
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);
  const displayFile = useQuickLook();

  useEffect(() => {
    getData();
  }, []);

  // Get
  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/ambassador/singleambassador", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // Delete
  const deleteInternShip = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/ambassador/deleteambassador/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Event has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };
  return (
    <>
      <h3 className="my-2 text-center text-uppercase">Your Applications</h3>
      <div className=" row">
        {/* <div className="col-md-4 text-end my-1">
          <select className="form-control text-uppercase" name="" id="">
            <option value="">Gyms</option>
            <option value="">Cafe's</option>
            <option value="">Lodge</option>
            <option value="">Bakery</option>
            <option value="">Classes</option>
            <option value="">Library</option>
            <option value="">Travels</option>
            <option value="">Laundry</option>
            <option value="">Garriage</option>
            <option value="">Medicals</option>
            <option value="">Restaurants</option>
            <option value="">Stationery</option>
            <option value="">Cyber Cafe</option>
            <option value="">Event Decors</option>
            <option value="">PG/Hostels</option>
            <option value="">Doctors/Clinic</option>
            <option value="">Salons/Parlours</option>
            <option value="">Mess/Parcel Points</option>
          </select>
        </div>
        <div className="col-md-4 text-start my-1"></div>
        <div className="col-md-4 text-start my-1">
          <input
            type="search"
            name=""
            id=""
            className="form-control"
            placeholder="Search"
          />
        </div> */}
      </div>
      <div className="container ">
        <div className="row  shadow-sm text-center mb-3">
          <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/myeventenquiries">
                Event Enquiries
              </NavLink>
            </h5>
          </div>
          <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/myenquiries">
                Merchant Enquiries
              </NavLink>
            </h5>
          </div>
          <div className="col border border-1 p-2 > ">
            <h5>
              <NavLink className="" to="/studentprofile/ambassadorentry">
                Ambassador Enquiries
              </NavLink>
            </h5>
          </div>
        </div>
      </div>

      <div className="container" style={{ overflowX: "scroll" }}>
        <table class="table table-striped border">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Full Name</th>
              <th>Email Id</th>
              <th>Contact No.</th>
              <th>College name</th>
              <th>College Id</th>
              <th>College Address</th>
              <th>City</th>
              <th>District</th>
              <th>State</th>
              <th>Pincode</th>
              <th>Description</th>
              <th>Status</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              return (
                <tr key={item.id}>
                  <th scope="row">{index + 1}</th>
                  <td>{item.fullname}</td>
                  <td>{item.email}</td>
                  <td>{item.contact_number}</td>
                  <td>{item.college_name}</td>
                  <td>
                    <a
                      href={item.image}
                      className="p-1 border-0 rounded-2 banner text-white"
                      target="_blank"
                    >
                      view
                    </a>
                  </td>
                  <td>{item.college_address}</td>
                  <td>{item.city}</td>
                  <td>{item.district}</td>
                  <td>{item.state}</td>
                  <td>{item.pincode}</td>
                  <td>{item.description}</td>
                  <td>{item.status}</td>

                  <td>
                    <div className="btn banner text-white">
                      <AiFillDelete onClick={() => deleteInternShip(item)} />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AmbassadorEntries;
